import React, { useState } from 'react';
import { Field, ErrorMessage, useFormikContext } from 'formik';
import Link from 'next/link';

export const StepEleven = () => {
  const { values } = useFormikContext();
  const [options, setOptions] = useState([
    {
      value: 'terms',
      label: 'I accept terms and conditions',
      isOpen: false,
      className: 'mt-adjust',
    },
  ]);
  return (
    <div className="main-container max-w-md mx-auto p-6 bg-white shadow-md rounded-md step">
      {/* <h6 className="text-lg font-bold mb-6">Consent and Contact Preference</h6> */}

      <div className="mb-6  form-radio2-main last-step">
        <div className="space-y-2">
          {options?.map((ele, i) => {
            return (
              <div className="flex items-center  form-check2">
                <Field
                  type="checkbox"
                  name="contactPreference"
                  value={ele?.value}
                  className="mr-2"
                  id={`contactPreference_${i}`}
                />
                <label className={ele?.className} htmlFor={`contactPreference_${i}`}>
                  {ele?.value === 'terms' ? (
                    <>
                      I accept <Link href={'/privacy-policy'}>terms & conditions </Link>{' '}
                      <span>*</span>
                    </>
                  ) : (
                    ele?.label
                  )}
                </label>
                <div className="moreOptions">{ele.descriptions}</div>
              </div>
            );
          })}
          <ErrorMessage name="contactPreference" component="div" className="required-text" />
        </div>
      </div>
    </div>
  );
};
